<button  *ngIf="['webpages', 'flyers'].includes(path)"  mat-button class="custom-btn" (click)="openAddDialog()">
    <span class="material-icons custom-icon">add_circle</span>
    <span *ngIf="path == 'webpages'" class="custom-color"> Add Webpage</span>
    <span *ngIf="path == 'flyers'" class="custom-color"> Add Flyer</span>
</button>